module.exports = __webpack_public_path__ + "static/media/largeDeliveryTruck_green.44961e49.svg";